var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsrbE(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.418,
    height: 90.628,
    viewBox: "0 0 60.418 90.628",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M107.479,513.479H47.061v90.628h60.418V513.479Z",
    transform: "translate(-47.061 -513.479)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240",
    transform: "translate(0.878 0.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M106.3,514.117V602.8H47.637V514.117H106.3",
    transform: "translate(-47.637 -514.117)",
    fill: "#1a1818"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244",
    transform: "translate(3.806 4.124)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178",
    "data-name": "Rectangle 178",
    width: 52.336,
    height: 14.706,
    transform: "translate(0.024)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 52.366,
    height: 54.062,
    transform: "translate(0 17.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241",
    transform: "translate(0.01 74.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M49.567,572.732v-7.178H60.08v1.68h-6.29v1.026h5.323v1.674H53.791v1.124h6.534v1.674Z",
    transform: "translate(-49.567 -565.375)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M65.032,567.706a.8.8,0,0,0-.611-.486,3.842,3.842,0,0,0-1.092-.132c-.929,0-1.344.151-1.344.419,0,1.061,7.414.4,7.414,3.007,0,1.661-2.494,2.474-6.034,2.474-3.4,0-5.621-1.107-5.711-2.4H61.7a1.026,1.026,0,0,0,.7.566,3.823,3.823,0,0,0,1.2.181c1.055,0,1.758-.187,1.758-.527,0-1.088-7.419-.342-7.419-3.078,0-1.524,2.364-2.29,5.589-2.29,3.576,0,5.208,1.015,5.516,2.27Z",
    transform: "translate(-45.341 -565.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M70.972,568.667h1.661c1.308,0,2.01-.19,2.01-.685s-.716-.749-1.7-.749H70.972Zm0,1.564v2.5H66.749v-7.178h6.088c4.29,0,5.708.656,5.708,2.051,0,.83-.659,1.519-2.165,1.761,1.36.273,2.185.443,2.185,1.891,0,.933-.055,1.258.446,1.258v.218H74.728a2.8,2.8,0,0,1-.21-1.256c0-.942-.288-1.245-2.256-1.245Z",
    transform: "translate(-40.591 -565.374)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M80.424,567.233v1.2h1.76c.842,0,1.452-.216,1.452-.627,0-.562-.833-.574-1.72-.574Zm0,2.5v1.323h1.842c1.047,0,1.833-.122,1.833-.658,0-.627-.982-.665-2.332-.665Zm-4.222,3v-7.178h6.161c2.9,0,5.211.39,5.211,1.81,0,.74-.863,1.279-1.684,1.559,1.395.2,2.144.874,2.144,1.644,0,1.6-2.2,2.165-5.551,2.165Z",
    transform: "translate(-35.652 -565.374)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242",
    transform: "translate(3.914 20.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M52.131,539.41l31.691-9.468L87,539.98l-15.876,4.738,1.3,4.108,14.668-4.378,3.17,10.043L75.6,558.86l1.369,4.326,16.395-4.9,3.179,10.034-32.207,9.621L52.131,539.41",
    transform: "translate(-52.131 -529.942)",
    fill: "#1a1818"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243",
    transform: "translate(1.477 3.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M50.531,526.611v-8.329h4.493v1.282H52.254v2.052h2.553V522.9H52.254v2.431h2.859v1.282Z",
    transform: "translate(-50.531 -518.144)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M53.84,518.282h1.793l1.273,6.056h.024l1.436-6.056h1.7l-2.179,8.329H55.871Z",
    transform: "translate(-48.802 -518.144)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M58.44,526.611v-8.329h4.491v1.282H60.16v2.052h2.555V522.9H60.16v2.431h2.861v1.282Z",
    transform: "translate(-46.399 -518.144)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M63.881,526.611H62.162v-8.329h3.177a1.838,1.838,0,0,1,1.41.554,2.3,2.3,0,0,1,.518,1.626,2.508,2.508,0,0,1-.346,1.35,1.629,1.629,0,0,1-1.18.693v.021l.387.07a1.323,1.323,0,0,1,.495.208,1.377,1.377,0,0,1,.428.478,1.778,1.778,0,0,1,.183.883c0,.128,0,.314.006.553s.012.483.027.738.038.487.064.7a1.741,1.741,0,0,0,.1.451H65.741a1.94,1.94,0,0,1-.178-.8c0-.276,0-.55,0-.819,0-.245,0-.48-.006-.7a1.51,1.51,0,0,0-.114-.582.855.855,0,0,0-.364-.4,1.52,1.52,0,0,0-.748-.151h-.446Zm0-4.73h.764a.74.74,0,0,0,.423-.116.822.822,0,0,0,.271-.294,1.215,1.215,0,0,0,.145-.4,2.37,2.37,0,0,0,.038-.416,1.226,1.226,0,0,0-.233-.848.848.848,0,0,0-.644-.247h-.764Z",
    transform: "translate(-44.454 -518.144)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M67.971,523.726l-2.156-5.444H67.7l1.232,3.518,1.311-3.518h1.754l-2.3,5.444v2.885H67.971Z",
    transform: "translate(-42.546 -518.144)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M73.186,526.8a3.1,3.1,0,0,1-1.643-.364,2.144,2.144,0,0,1-.846-.968,4.078,4.078,0,0,1-.3-1.378c-.03-.515-.047-1.046-.047-1.591s.017-1.089.047-1.6a4,4,0,0,1,.3-1.37,2.132,2.132,0,0,1,.846-.964,3.871,3.871,0,0,1,3.284,0,2.112,2.112,0,0,1,.845.964,4.072,4.072,0,0,1,.306,1.37c.03.516.046,1.049.046,1.6s-.015,1.076-.046,1.591a4.153,4.153,0,0,1-.306,1.378,2.123,2.123,0,0,1-.845.968A3.09,3.09,0,0,1,73.186,526.8Zm0-1.247a.89.89,0,0,0,.582-.178,1.157,1.157,0,0,0,.33-.547,4.21,4.21,0,0,0,.148-.952c.024-.39.037-.848.037-1.378s-.012-.991-.037-1.379a4.2,4.2,0,0,0-.148-.952,1.151,1.151,0,0,0-.33-.547,1.034,1.034,0,0,0-1.165,0,1.083,1.083,0,0,0-.329.547,4.023,4.023,0,0,0-.149.952q-.034.582-.035,1.379c0,.53.012.988.035,1.378a4.037,4.037,0,0,0,.149.952,1.088,1.088,0,0,0,.329.547A.892.892,0,0,0,73.186,525.549Z",
    transform: "translate(-40.179 -518.191)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M74.98,526.611v-8.329h2.329l2.185,5.766h.024v-5.766h1.611v8.329H78.858l-2.246-6.091h-.024v6.091Z",
    transform: "translate(-37.757 -518.144)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M79.967,526.611v-8.329h4.5v1.282H81.692v2.052h2.55V522.9h-2.55v2.431H84.55v1.282Z",
    transform: "translate(-35.152 -518.144)",
    fill: "#1a1818"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsrbE);
export default __webpack_public_path__ + "static/media/esrb-e.864f08017ed7f5667d0f077a93be6600.svg";
export { ForwardRef as ReactComponent };